module.exports = __webpack_public_path__ + "img/mid-logo.eb7f4bdf.png";